import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { IUserAccount, Page } from '../../models';
import { Router } from '@angular/router';
import { AppData, EncounterCommunication, HttpService } from '../../services';
import { finalize, takeUntil } from 'rxjs';
import { Appointment } from '../../entities';
import { ApiResources } from '../../helpers';


@Component({
    selector: 'nurse-header',
    templateUrl: './nurse-header.html',
})


export class NurseHeaderComponent implements OnDestroy, OnInit {
    @Input() patientId: string;
    @Input() appointmentId: string;
    page: Page;
    isAdmission: boolean;
  /*  appointmentId: string;*/
    roleId: number;
    encounterCommunicationSubscription: any;
    appointment: Appointment;
    encryptedAppointmentId: string;
    constructor(
        private readonly httpService: HttpService,
        private readonly appData: AppData,
        //private readonly notifyService: NotifyService,
        private readonly encounterCommunication: EncounterCommunication,
        private readonly router: Router,


    ) {
        this.page = new Page();

    }


    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {              
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    const url = this.router.url;
                    this.encryptedAppointmentId = url.split("/")[3];
                    this.findAppointment(this.encryptedAppointmentId);

                } else {
                    this.page.userAccount = undefined;
                }
            });
    }
    ngOnDestroy() {
        this.page.unsubscribeAll();

    }
    private findAppointment(appointmentId: string) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = true;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Appointment) => {
                this.appointment = response;
            });
    }
    onback() {
        this.router.navigate(['app/nurse-module/actions/:id']);
    }
}